export default "__VITE_PUBLIC_ASSET__edd909c9__"